import React, { Component } from 'react';
import config from '../../config';
import { localiseAmount, roundCurrency } from '../Common/Helper';
import { HTMLTrans } from '../Common/Translations';

class ShippingCreditExpiryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expiringCredits: [],
            nonExpiringCredits: [],
        };
    }

    formatAmount(amount, currency) {
        return `${currency} ${localiseAmount(roundCurrency(amount))}`;
    }

    async getCredits() {
        return (await $.get(`${config.localeApi}/shipping_credit`)).data;
    }

    componentDidMount() {
        this.getCredits().then(credits => {
            const expiringCredits = credits.filter(credit => credit.expiry_date !== null);
            const nonExpiringCredits = credits.filter(credit => credit.expiry_date === null);
            this.setState({expiringCredits, nonExpiringCredits});
        });
    }

    render() {
        const { expiringCredits, nonExpiringCredits } = this.state;
        let expiringCreditRows = null;
        let nonExpiringCreditRow = null;

        if (expiringCredits.length !== 0) {
            expiringCreditRows = expiringCredits.map(({ currency, credit, expiry_date }, key) => {
                const amount = this.formatAmount(credit, currency);
                const date = expiry_date.split(' ')[0].split('-').reverse().join('-');

                return (
                    <li key={key} className="shipping-credit-expiry-modal__credit py-2">
                        <HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_expiringcredit" variables={{amount, date}}>
                            {amount} credit will expire on {date}
                        </HTMLTrans>
                    </li>
                );
            });
        }

        if (nonExpiringCredits.length !== 0) {
            const nonExpiringCreditSum = nonExpiringCredits.reduce((sum, curr) => sum + curr.credit, 0);
            const amount = this.formatAmount(nonExpiringCreditSum, nonExpiringCredits[0].currency);

            nonExpiringCreditRow = (
                <li className="shipping-credit-expiry-modal__credit py-2">
                    <HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_nonexpiringcredit" variables={{amount}}>
                        {amount} credit has no expiry date
                    </HTMLTrans>
                </li>
            );
        }

        return (
            <div className="shipping-credit-expiry-modal modal fade" id="shipping-credit-expiry-modal" tabIndex="-1" role="dialog" aria-labelledby="shipping-credit-expiry-modal-title" aria-hidden="true">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="modal-header align-items-start">
                            <div>
                                <h5 className="shipping-credit-expiry-modal__title modal-title" id="shipping-credit-expiry-modal-title"><HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_title">Shipping Credit Expiry</HTMLTrans></h5>
                                <div className="shipping-credit-expiry-modal__description mt-2"><HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_description">Shipping credits will expire after their promotional period. Spend them before they expire!</HTMLTrans></div>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body py-0">
                            {expiringCredits.length !== 0 || nonExpiringCredits.length !== 0
                                ? <ol className="shipping-credit-expiry-modal__credits list-unstyled">{expiringCreditRows}{nonExpiringCreditRow}</ol>
                                : <div className="text-muted"><HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_empty">No active credits</HTMLTrans></div>}
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button type="button" className="btn btn-primary" data-dismiss="modal"><HTMLTrans id="account.globalshippingcredit_shippingcreditexpirymodal_closebuttontext">Okay</HTMLTrans></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShippingCreditExpiryModal;



// WEBPACK FOOTER //
// ./src/GlobalShippingCredit/ShippingCreditExpiryModal.js